import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Heading,
  Text,
  Flex,
  useColorModeValue,
  useColorMode,
  Badge,
  HStack,
  Button,
  Icon,
} from "@chakra-ui/react";
import { FaBookOpen, FaExpandArrowsAlt, FaCompressArrowsAlt, FaExternalLinkAlt } from "react-icons/fa";
import { timelineHtml } from "./timelineHtml";
import "./Timeline.css";

const Information = () => {
  const { colorMode } = useColorMode();
  const [allOpen, setAllOpen] = useState(false);
  const containerRef = useRef(null);

  const cardBg = useColorModeValue("white", "navy.700");
  const cardBorder = useColorModeValue(
    "1px solid rgba(226, 232, 240, 0.8)",
    "1px solid rgba(255, 255, 255, 0.08)"
  );
  const textColor = useColorModeValue("slate.800", "white");
  const subtitleColor = useColorModeValue("slate.500", "slate.400");

  // Toggle all scientific details open/closed
  const toggleAllDetails = () => {
    if (!containerRef.current) return;
    const detailsElements = containerRef.current.querySelectorAll("details");
    const nextState = !allOpen;
    detailsElements.forEach((d) => {
      d.open = nextState;
    });
    setAllOpen(nextState);
  };

  return (
    <Flex direction="column" pt={{ base: "62px", md: "75px", xl: "88px" }} gap="20px">
      <Box
        p={{ base: "14px 10px", sm: "18px", md: "32px" }}
        bg={cardBg}
        borderRadius={{ base: "16px", md: "24px" }}
        border={cardBorder}
        shadow="sm"
        className={colorMode === "dark" ? "dark-theme" : "light-theme"}
      >
        {/* Top Controls Bar */}
        <Flex
          justify="space-between"
          align="center"
          mb="12px"
          pb="16px"
          borderBottom="1px solid"
          borderColor={cardBorder}
          wrap="wrap"
          gap="12px"
        >
          <HStack spacing="10px">
            <Icon as={FaBookOpen} color="teal.500" boxSize="20px" />
            <Box>
              <Text fontSize="xs" fontWeight="800" color="teal.500" textTransform="uppercase" letterSpacing="0.08em">
                Curated Scientific Bibliography
              </Text>
              <Heading size="md" color={textColor} fontWeight="800">
                XP in Tunisia: Research Timeline & Literature
              </Heading>
            </Box>
          </HStack>

          <HStack spacing="10px">
            <Button
              size="sm"
              variant="outline"
              colorScheme="teal"
              borderRadius="full"
              leftIcon={<Icon as={allOpen ? FaCompressArrowsAlt : FaExpandArrowsAlt} />}
              onClick={toggleAllDetails}
            >
              {allOpen ? "Collapse References" : "Expand All References"}
            </Button>
          </HStack>
        </Flex>

        {/* Source-Linked Interactive Timeline Container */}
        <Box
          ref={containerRef}
          className="timeline-root"
          dangerouslySetInnerHTML={{ __html: timelineHtml }}
        />
      </Box>
    </Flex>
  );
};

export default Information;
